export const heroImage =
  'https://cdn.magicpatterns.com/uploads/7BrmvAq85DKWNUGyTBT9BR/ChatGPT_Image_18_sept_2026,_23_25_19-Photoroom.webp'

/** Enlace de pago. */
export const checkoutUrl =
  'https://mega-pack-eduacion-fisica.impultienda.ar/checkout'
export const price = '$19'
export const fullPrice = '$197'
export const volumesValue = '$120'
export const bonusValue = '$77'
export const savings = '$178'
export const discountPercent = '90%'
export const currency = 'USD'

export interface Stat {
  value: string
  label: string
}

export const stats: Stat[] = [
  { value: '120', label: 'Sesiones completas' },
  { value: '6', label: 'Volúmenes estratégicos' },
  { value: '5', label: 'Bonos exclusivos' },
  { value: '∞', label: 'Acceso de por vida' },
]

export interface Proof {
  value: string
  label: string
}

export const proof: Proof[] = [
  { value: '2.500+', label: 'Docentes en Latinoamérica y España' },
  { value: '4.9/5', label: 'Calificación promedio' },
]

export const heroBadges: string[] = [
  'Pago seguro en tu moneda local',
  'Acceso inmediato',
  '100% PDF imprimible',
  'Garantía de 7 días',
]

/** La realidad del docente de Educación Física. */
export interface Cost {
  title: string
  detail: string
}

export const costs: Cost[] = [
  {
    title: 'Domingos enteros diseñando unidades didácticas',
    detail: 'Y después nadie las lee. Tu tiempo libre se evapora.',
  },
  {
    title: 'Los estudiantes se aburren y terminas sacando el balón',
    detail: 'Sales del paso, pero la clase deja de enseñar algo.',
  },
  {
    title: 'El papeleo de las normativas te agobia',
    detail: 'Programas, competencias e informes… y ninguna plantilla lista.',
  },
  {
    title: 'Llegas a la clase cansado y sin progresión clara',
    detail: 'La sesión arranca improvisada y se nota desde el primer minuto.',
  },
  {
    title: 'Los estudiantes no mejoran de forma visible',
    detail: 'Sin coherencia de clase a clase no hay avance que se pueda medir.',
  },
  {
    title: 'No sabes cómo evaluar por competencias',
    detail: 'Las notas terminan siendo una impresión personal, no un dato.',
  },
]

/** Lo que incluye el acceso completo. */
export const included: string[] = [
  '6 volúmenes estratégicos',
  '120 sesiones completas',
  `5 bonos (valor ${bonusValue} ${currency})`,
  'Adaptable a Primaria y Secundaria',
  'Acceso inmediato en PDF',
  'Acceso de por vida',
]

/** El cierre: lo que dejas de hacer y lo que ganas. */
export interface Outcome {
  text: string
  positive: boolean
}

export const outcomes: Outcome[] = [
  { text: 'Sin domingos perdidos armando planificaciones', positive: false },
  { text: 'Sin clases improvisadas para salir del paso', positive: false },
  { text: 'Sin evaluaciones subjetivas ni informes vagos', positive: false },
  { text: 'Sin buscar actividades sueltas en internet', positive: false },
  { text: 'Sin depender de material ni de presupuesto', positive: false },
  { text: 'Con tu año entero planificado desde el día 1', positive: true },
]
